import authHeader from './auth-header';
import Api from './api';
import { AwsApiKeys } from 'app/models/awsapikeys';

const API_URL = process.env.REACT_APP_AQUA_API_ENDPOINT
const ENDPOINT_BASE = "EDiaryAwsApiKey"

class EDiaryApiKeysService {
    async getAllApiKeys(): Promise<AwsApiKeys[]> {
        return (await Api().get(`${API_URL}/${ENDPOINT_BASE}/list`, { headers: authHeader() })).data;
    }

    async createApiKey(apiKey: AwsApiKeys) {
        return (await Api().post(`${API_URL}/${ENDPOINT_BASE}/create`, apiKey, { headers: authHeader() })).data;
    }

    async deleteApiKey(apiKeyId: string) {
        return await Api().delete(`${API_URL}/${ENDPOINT_BASE}/${apiKeyId}`, { headers: authHeader() });
    }

    async updateApiKey(apiKey: AwsApiKeys) {
        return await Api().put(`${API_URL}/${ENDPOINT_BASE}/${apiKey.apiKeyId}`, apiKey,
            { headers: authHeader() });
    }
}
export default new EDiaryApiKeysService();